export default __webpack_public_path__ + "static/Sketch-changing-button-state-a386468a8306ecab76584ee938c5c958.gif";